import {
  AppKeys,
  newMsg,
  MessageType,
  newTag,
} from '../../../core/localization';
import { Groups, SelectMode } from '../../../models';

export const msgAssignHeader = newMsg(AppKeys.ReadRigth_Assign_Header);
export const msgEditHeader = newMsg(AppKeys.ReadRigth_Edit_Header);
export const msgUpdating = newMsg(AppKeys.ReadRigth_Edit_Updating);
export const msgAssignBtn = newMsg(AppKeys.Btn_Assign);
export const msgAssignCreateBtn = newMsg(AppKeys.ReadRigth_Btn_AssignCreate);
export const msgUnassignBtn = newMsg(AppKeys.Btn_Remove);
export const msgDevicesAll = newMsg(AppKeys.Devices_Mode_All);
export const msgDevicesSelected = newMsg(AppKeys.Devices_Mode_Selected);

export const msgSubtextOrders = (total: number) =>
  newMsg(AppKeys.ReadRigth_Subtext_Orders, [newTag('total', total)]);

export const msgSubtextDTypes = (total: number) =>
  newMsg(AppKeys.ReadRigth_Subtext_DTypes, [newTag('total', total)]);

export const getViewMsg = (groupedBy: Groups, numKeys: number) => {
  switch (groupedBy) {
    case Groups.ORDERS:
      return msgSubtextOrders(numKeys);
    case Groups.DEVICETYPES:
      return msgSubtextDTypes(numKeys);
    default:
      return '' as MessageType;
  }
};

export const msgNumDevices = (total: number) =>
  newMsg(AppKeys.Devices_ToBeUpdated, [newTag('count', total)]);

export const msgConfirmDevices = () =>  newMsg(AppKeys.Devices_ToBeConfirmed);
export const msgNoOrders = newMsg(AppKeys.Orders_EmptySelection_Warn);
export const msgNoProducts = newMsg(AppKeys.DTypes_EmptySelection_Warn);

export const msgAssignSuccess = newMsg(
  AppKeys.ApiMykeys_ReadRight_Assign_Success
);
export const msgAssignError = newMsg(AppKeys.ApiMykeys_ReadRight_Assign_Error);

export const msgEmailLabel = newMsg(AppKeys.ReadRigth_Email_Label);

export const msgEmailValidating = newMsg(
  AppKeys.ReadRigth_CustomerInfo_Validating
);
export const msgEmailError = newMsg(AppKeys.ReadRigth_CustomerInfo_Email_Error);

export const msgUserNotFoundError = newMsg(
  AppKeys.ReadRigth_CustomerInfo_UserNotFound_Error
);

export const warnUserNotFound = newMsg(
  AppKeys.ReadRigth_CustomerInfo_UserNotFound_Warn
);

export const warnUserToAssignNotFound = newMsg(
  AppKeys.ReadRigth_CustomerInfo_UserToAssignNotFound_Warn
);

export const registerUserToAssign = newMsg(
  AppKeys.ReadRigth_CustomerInfo_RegisterUser
);

export const registerHere = newMsg(AppKeys.Com_Here);



export const msgUserFound = (email: string, customerName: string) =>
  newMsg(AppKeys.ReadRigth_CustomerInfo_UserFound, [
    newTag('email', email),
    newTag('customerName', customerName),
  ]);

export const warnUserFound = (customerName: string) =>
  newMsg(AppKeys.ReadRigth_CustomerInfo_UserFound_Warn, [
    newTag('customerName', customerName),
  ]);

export const msgValidatingError = newMsg(AppKeys.ReadRigth_CustomerInfo_Error);

export const msgUnassignSuccess = newMsg(
  AppKeys.ApiMykeys_ReadRigth_Remove_Success
);
export const msgUnassignError = newMsg(
  AppKeys.ApiMykeys_ReadRigth_Remove_Error
);

export const getMode = (groupedBy: Groups, keys: string[] = []) =>
  groupedBy === Groups.DEVICES && keys.length === 0
    ? SelectMode.All
    : SelectMode.Selected;
